import { filter, values, pick } from 'lodash'

export function createSearch<T>(searchableDataKeys: string[]) {
  return (items: T[], term: string) => {
    term = `${term || ''}`.trim().toLowerCase()
    if (!term) {
      return items
    }

    return filter(items, (data) => {
      const dataKeys = searchableDataKeys && searchableDataKeys.length ? [...searchableDataKeys] : Object.keys(data)
      const dataStr = values(pick(data, dataKeys))
        .map((v) => `${v || ''}`.toLowerCase())
        .join('◬')
      return dataStr.indexOf(term) !== -1
    })
  }
}
